import { render } from "./hover-bar.vue?vue&type=template&id=70fc2154"
import script from "./hover-bar.vue?vue&type=script&lang=js"
export * from "./hover-bar.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__